import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';
import { useAppTheme } from '@/providers/theme-provider';

export function LoadingScreen({ message = "Loading..." }: { message?: string }) {
  const theme = useAppTheme();
  return (
    <View className="flex-1 justify-center items-center bg-background">
      <ActivityIndicator
        size="large"
        color={theme.colors.primary}
        className="mb-4"
      />
      <Text className="text-lg text-foreground">
        {message}
      </Text>
    </View>
  );
}
